exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog .modal-content {\n  max-width: 550px !important;\n  width: 550px !important;\n  margin-left: -100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/verify-product-modal/verify-product-modal.component.scss
// module id = ../../../../../src/app/components/verify-product-modal/verify-product-modal.component.scss
// module chunks = main